module.exports = __webpack_public_path__ + "assets/1c3efe2b5164a1917b1fd2c0091f9052.mp3";